import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import _ from 'lodash';
import { RESET_STATE } from '../../shared/actions/common-actions';
import validationRuleGroupMap from '../validation-rule-group-map';
import { ValidationProcess, ValidationRuleType } from '../types';
import { validateAction, validateLoadingAction } from './actions';

const buildRoute = (rule: ValidationRuleType) => {
  const { entities, validationRuleGroup, validationRuleDisplayZone } = rule;
  const { route, zone } = validationRuleGroupMap[validationRuleGroup] || [];
  const hash = _.get(zone, validationRuleDisplayZone ?? '', '');
  return `/files/${entities.entryForm}/${route ? route(entities) : ''}${hash}`;
};

interface ValidationRuleState {
  isLoading: boolean;
  values: { [key: string]: ValidationRuleType[] };
}

const initialState: ValidationRuleState = {
  isLoading: false,
  values: {
    [ValidationProcess.APPROVAL]: [],
    [ValidationProcess.SUBMISSION]: [],
    [ValidationProcess.LINK_FINAL_TERMS]: [],
  },
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(validateLoadingAction, (state, action: PayloadAction<{ isLoading: boolean }>) => {
      state.isLoading = action.payload.isLoading;
    })
    .addCase(
      validateAction,
      (
        state,
        action: PayloadAction<{
          isLoading: boolean;
          values?: Record<ValidationProcess, ValidationRuleType[] | undefined>;
        }>
      ) => {
        state.isLoading = action.payload.isLoading;

        const violationsByProcess = action.payload.values as Partial<Record<ValidationProcess, ValidationRuleType[]>>;
        const processes = Object.keys(violationsByProcess) as ValidationProcess[];

        processes.forEach((key) => {
          violationsByProcess[key]?.forEach((rule) => {
            rule.route = buildRoute(rule);
          });
        });

        state.values = { ...violationsByProcess };
      }
    )
    .addCase(RESET_STATE, (state) => {
      state.values = initialState.values;
      state.isLoading = initialState.isLoading;
    });
});
